import * as Yup from 'yup';
import { emailRegex } from '@pharmaplan/common';
import { nameRegex, phoneRegex } from '../../../../helpers/Constants';
import strings from '../../../../localization';
import { taxNumberValidation } from '../../../../helpers/commonValidators';

const hourlyRateValidator = Yup.number()
  .typeError(strings.mustBeNumber)
  .moreThan(
    0,
    strings.formatString(strings.pleaseEnterMoreThan, '0') as string,
  )
  .max(
    999.99,
    strings.formatString(strings.pleaseEnterLessThan, '1000') as string,
  );

const hourlyRateLessThan = (
  billingField: string,
  message: string,
) =>
  hourlyRateValidator.max(
    Yup.ref(billingField),
    message,
  );

export const adminConfigurationValidator = () =>
  Yup.object().shape({
    representativeName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    representativeEmail: Yup.string()
      .required(strings.requiredField)
      .matches(emailRegex, strings.emailValid),
    representativePhone: Yup.string()
      .required(strings.requiredField)
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`),
    ratePharmacistDays: Yup.number()
      .required(strings.requiredField)
      .typeError(strings.mustBeNumber),
    minHourWorkshift: Yup.number()
      .required(strings.requiredField)
      .typeError(strings.mustBeNumber),
    pharmacyRate: Yup.number()
      .required(strings.requiredField)
      .typeError(strings.mustBeNumber),
    pharmacyWeekDayHourlyRate: hourlyRateValidator.nullable(),
    pharmacyWeekendHourlyRate: hourlyRateValidator.nullable(),
    pharmacyRateForTech: hourlyRateValidator.nullable(),
    pharmacyWeekDayHourlyRateForTech: hourlyRateValidator.nullable(),
    pharmacyWeekendHourlyRateForTech: hourlyRateValidator.nullable(),

    pharmacistRate: hourlyRateLessThan('pharmacyRate', strings.cannotBeMoreThanBill),
    pharmacistWeekDayHourlyRate: hourlyRateLessThan('pharmacyWeekDayHourlyRate', strings.cannotBeMoreThanBill),
    pharmacistWeekendHourlyRate: hourlyRateLessThan('pharmacyWeekendHourlyRate', strings.cannotBeMoreThanBill),
    technicianRate: hourlyRateLessThan('pharmacyRateForTech', strings.cannotBeMoreThanBill),
    technicianWeekDayHourlyRate: hourlyRateLessThan('pharmacyWeekDayHourlyRateForTech', strings.cannotBeMoreThanBill),
    technicianWeekendHourlyRate: hourlyRateLessThan('pharmacyWeekendHourlyRateForTech', strings.cannotBeMoreThanBill),

    tpsNumber: taxNumberValidation,
    tvqNumber: taxNumberValidation,
  });
